import { render, staticRenderFns } from "./UaRating.vue?vue&type=template&id=346f90eb&scoped=true&"
import script from "./UaRating.vue?vue&type=script&lang=js&"
export * from "./UaRating.vue?vue&type=script&lang=js&"
import style0 from "./UaRating.vue?vue&type=style&index=0&id=346f90eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346f90eb",
  null
  
)

export default component.exports